import React, { FC } from 'react';
import cx from 'classnames';

import useThemeBlock from '@/hooks/useThemeBlock';
import { Link } from '@/helpers/Link/render';
import { CardLinkProps } from '@/helpers/CardControls/typings';
import { Image } from '@/components/molecules/Image/render';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type CardIconTextProps = ThemeProps & {
	title: string;
	link?: CardLinkProps;
	image?: ImageProps;
	content?: string;
};

/**
 * COMPONENT
 */
export const CardIconText: FC<CardIconTextProps> & BlockConfigs = ({
	title,
	image,
	content,
	link: { href = null, opensInNewTab = false, ...linkProps } = {},
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const rootClass = cx(
		'supt-card supt-cardIconText',
		getStyles(blockTheme),
		href && 'supt-withLink'
	);

	return (
		<div
			className={rootClass}
			data-block={block.slug}
			data-variant={variant}
		>
			{image?.src && (
				<div className="supt-cardIconText__imageWrapper">
					<Image {...image} className="supt-cardIconText__image" />
				</div>
			)}

			{href ? (
				<Link
					className="supt-cardIconText__link"
					href={href}
					{...(opensInNewTab && {
						target: '_blank',
						rel: 'noopener noreferrer',
					})}
					{...linkProps}
				>
					<h3
						className="supt-cardIconText__title"
						dangerouslySetInnerHTML={{ __html: title }}
					/>
				</Link>
			) : (
				<h3
					className="supt-cardIconText__title"
					dangerouslySetInnerHTML={{ __html: title }}
				/>
			)}
			<div
				className="supt-cardIconText__content"
				dangerouslySetInnerHTML={{ __html: content }}
			/>
		</div>
	);
};

CardIconText.slug = block.slug;
CardIconText.title = block.title;
